import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/supplier-returns/')({
  component: () => <div>Supplier Returns</div>,
});
